import React, { useState } from "react";
import SettingsSection from "../SettingsSection";
import RolePicker from "../RolePicker";

export default function ShopSection({ roles, shopItems, setShopItems }) {
  const [newItem, setNewItem] = useState({
    roleId: "",
    price: 100,
    description: "",
    category: "color",
  });

  const roleName = (roleId) =>
    roles.find((r) => r.id === roleId)?.name || roleId;

  const addItem = () => {
    if (!newItem.roleId || !newItem.description) return;
    if (shopItems.some((item) => item.roleId === newItem.roleId)) return;

    const role = roles.find((r) => r.id === newItem.roleId);
    setShopItems([
      ...shopItems,
      {
        name: role?.name || "Role",
        roleId: newItem.roleId,
        price: Number(newItem.price) || 0,
        description: newItem.description,
        category: newItem.category,
      },
    ]);
    setNewItem({
      roleId: "",
      price: 100,
      description: "",
      category: "color",
    });
  };

  const removeItem = (roleId) => {
    setShopItems(shopItems.filter((item) => item.roleId !== roleId));
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Roles sold for Essence in the leveling shop. You can also use{" "}
        <code>/shop-add</code> and <code>/shop-remove</code> in Discord.
      </p>

      {shopItems.length > 0 ? (
        <div className="settings-item-list">
          {shopItems.map((item) => (
            <div key={item.roleId} className="settings-item-row">
              <div className="settings-item-info">
                <strong>{roleName(item.roleId)}</strong> - {item.price} Essence
                <br />
                <span className="settings-item-meta">
                  {item.category === "color" ? "Color Roles" : "Perks"}{" "}
                  · {item.description}
                </span>
              </div>
              <button
                type="button"
                className="manage-btn settings-item-action"
                onClick={() => removeItem(item.roleId)}
              >
                REMOVE
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="help-text" style={{ marginBottom: "15px" }}>
          No shop items yet.
        </p>
      )}

      <label className="input-label">ADD SHOP ITEM</label>
      <RolePicker
        roles={roles}
        value={newItem.roleId}
        onChange={(v) => setNewItem({ ...newItem, roleId: v })}
        emptyLabel="Select a role…"
        placeholder="Select a role…"
      />

      <input
        type="number"
        className="settings-input"
        value={newItem.price}
        onChange={(e) =>
          setNewItem({ ...newItem, price: parseInt(e.target.value) || 0 })
        }
        placeholder="Price in Essence"
      />

      <input
        type="text"
        className="settings-input"
        value={newItem.description}
        onChange={(e) =>
          setNewItem({ ...newItem, description: e.target.value })
        }
        placeholder="Description"
      />

      <select
        value={newItem.category}
        onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
        className="settings-input"
      >
        <option value="color">Color Roles (Hues)</option>
        <option value="perk">Perks (Utility)</option>
      </select>

      <button
        type="button"
        className="manage-btn"
        style={{ marginTop: "10px" }}
        onClick={addItem}
      >
        ADD TO SHOP
      </button>
    </SettingsSection>
  );
}
